import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import {ReactTitle} from 'react-meta-tags';

import './App.css';
import Player from './components/player_material_ui';
import Content from './components/Content';
import Audio from './components/Audio';

const muiTheme = getMuiTheme({
  fontFamily: 'Roboto, sans-serif',
  palette: {
      primary1Color: '#ffff',
      accent1Color: '#69f0ae',
      textColor: '#666666',
  },
  textField: {
    textColor: '#fff',
    hintColor: '#ADADAD',
    borderColor: '#ADADAD',
    disabledTextColor: '#ADADAD',
  },
})

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPlaying: false,

      coverUrl: require('./components/images/artwork-not-found.png'),
      trackTitle: "Ready",
      trackAuthor: "to play",
      trackId: '',

      maxProgress: 0, //seconds
      currentProgress: 0, //seconds

      volume: 100, //0%

      previewUrl: null,
      
      source: 'Spotify',
      contentVisible: true,

      loading: false,
    }
  }

  // Custom Methods

  onProgressChange = (value) => {
    this.setState({currentProgress: value}, () => {

      this.rap.audioEl.currentTime = this.state.currentProgress

    });
  }

  onVolumeChange = (value) => {
    this.setState({volume: value});
  }

  onTogglePlayPause = () => {
    this.setState({isPlaying: !this.state.isPlaying}, () => {

      if (this.state.isPlaying) this.rap.audioEl.play()

      else this.rap.audioEl.pause()

    });
  }

  onPlayTrack = (previewUrl, trackTitle, trackAuthor, trackId, coverUrl, maxProgress, toggle) => {
    if (toggle && this.state.previewUrl) {this.onTogglePlayPause(); return}

    if (this.state.contentVisible) {
      this.setState({
        contentVisible: false,
      }, () => {
        setTimeout(() => {
          this.setState({
            previewUrl,
            trackTitle,
            trackAuthor,
            trackId,
            coverUrl,
            maxProgress,
          }, () => this.rap.audioEl.play());
        }, 400)
      });
    }

    else {
      this.setState({
        previewUrl,
        trackTitle,
        trackAuthor,
        trackId,
        coverUrl,
        maxProgress,
      }, () => this.rap.audioEl.play());
    }
  }

  onCanPlay = () => {
    this.setState({loading: false});
  }

  onWaiting = () => {
    this.setState({loading: true});
  }

  onChangeSource = (source) => {
    this.setState({source});
  }

  onToggleContent = () => {
    this.setState({contentVisible: !this.state.contentVisible});
  }

  // Handlers

  handleAudio = (event) => {

    if (event.type === "play") {
        this.setState({isPlaying: true})
    }

    if (event.type === "pause") {
        this.setState({isPlaying: false})
    }

    if (event.type === "ended") {
        this.setState({isPlaying: false})
    }

  }

  handleListen = (event) => {
    this.setState({
      currentProgress: event,
    })
  }
  
  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="wrapper">
          <ReactTitle title={this.state.previewUrl ? `${this.state.trackTitle} by ${this.state.trackAuthor}` : 'Material Player'}/>
          <div className="queue-button-mobile">
            <IconButton onClick={this.onToggleContent}>
              <FontIcon color={this.state.contentVisible ? "#ADADAD" : "#fff"} className="material-icons">
                {this.state.contentVisible ? 'expand_more' : 'queue_music'}
              </FontIcon>
            </IconButton>
            <div className={`queue-button-mobile--dimmer ${this.state.contentVisible ? "queue-button-mobile--dimmer__hidden" : ""}`} />
          </div>
          <div className={`player ${this.state.contentVisible ? 'player__blur' : ''}`} >
            <Player 
              isPlaying={this.state.isPlaying}

              coverUrl={this.state.coverUrl}
              trackTitle={this.state.trackTitle}
              trackAuthor={this.state.trackAuthor}

              maxProgress={this.state.maxProgress}
              currentProgress={this.state.currentProgress}
              
              volume={this.state.volume}

              width='100%'
              height='100%'

              loading={this.state.loading}

              onProgressChange={this.onProgressChange}
              onVolumeChange={this.onVolumeChange}
              onTogglePlayPause={this.onTogglePlayPause} />
          </div>
          <Content
          contentVisible={this.state.contentVisible}
          source={this.state.source}
          onChangeSource={this.onChangeSource}
          playing={this.state.trackId}
          isPlaying={this.state.isPlaying}
          onPlayTrack={this.onPlayTrack}/>
          <Audio 
            src = {this.state.previewUrl}
            className = "hidden"
            volume = {this.state.volume / 100}
            listenInterval = {350}
            onPlay = {this.handleAudio}
            onPause = {this.handleAudio}
            onEnded = {this.handleAudio}
            onListen = {this.handleListen}
            onCanPlay = {this.onCanPlay}
            onWaiting = {this.onWaiting}
            ref = {(element) => { this.rap = element }} />
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.jsx